import React from "react";
import ReportsDetails from "./ReportsDetails";

const RestaurantReport = () => {
  return <ReportsDetails />;
};

export default RestaurantReport;
